import { generateUUID } from "@drpcrd/utils/shared";
import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Twitch logo icon component
 */
export const TwitchLogo: FC<Props> = ({ ...props }) => {
  const clipPathId = `twitch-logo-clip-${generateUUID()}`;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M19.1604 11.2857L16.2961 14.1429H13.4318L10.9255 16.6429V14.1429H7.70312V3.42859H19.1604V11.2857Z"
          fill="white"
        />
        <path
          d="M6.98665 2L3.40625 5.57143V18.4286H7.70273V22L11.2831 18.4286H14.1475L20.5922 12V2H6.98665ZM19.16 11.2857L16.2957 14.1429H13.4314L10.9251 16.6429V14.1429H7.70273V3.42857H19.16V11.2857Z"
          fill="black"
        />
        <path
          d="M17.0122 5.92859H15.5801V10.2143H17.0122V5.92859Z"
          fill="black"
        />
        <path
          d="M13.0728 5.92859H11.6406V10.2143H13.0728V5.92859Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="17.1859"
            height="20"
            fill="white"
            transform="translate(3.40625 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
